import { render, staticRenderFns } from "./Autoreply.vue?vue&type=template&id=bb56631a"
import script from "./Autoreply.vue?vue&type=script&lang=js"
export * from "./Autoreply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports